import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  parseRunsSearch,
  type RunsSearchPatch,
  withRunsSearch,
} from '~portal/components/admin/automations/runs/run-search';
import { RunsList } from '~portal/components/admin/automations/runs/RunsList';
import { logger } from '~portal/lib';

/**
 * @desc Automations → Runs (H2-7, task 8.4; D9). The view (overview by workflow, or `view=all`)
 * and the flat list's filters live in the URL (`parseRunsSearch`), so either can be shared or
 * bookmarked.
 */
export const Route = createFileRoute('/_protected/admin/ario/runs')({
  validateSearch: parseRunsSearch,
  component: AutomationRunsPage,
});

function AutomationRunsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const update = (patch: RunsSearchPatch) => {
    navigate({
      search: (prev) => withRunsSearch(prev, patch),
      // Filters and the view switch change the page in place; it keeps its scroll position.
      resetScroll: false,
    }).catch((err: unknown) => {
      logger.error('[AutomationRuns] Navigation failed', {
        error: err instanceof Error ? err.message : String(err),
      });
    });
  };

  return <RunsList search={search} onSearch={update} />;
}
